import * as React from "react";
import { forwardRef } from "react";
const SvgStarEmpty = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 64 61",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "m62 21.2-19.3-2.7-8.5-17.2c-.3-.4-.7-.8-1.1-1a2.4 2.4 0 0 0-3.3 1l-8.5 17.2L2 21.2c-.6 0-1 .3-1.4.7a2.4 2.4 0 0 0 0 3.4l14 13.3-3.4 18.9a2.3 2.3 0 0 0 1 2.3 2.4 2.4 0 0 0 2.5.2L32 51l17.2 9c.4.2 1 .3 1.5.2a2.4 2.4 0 0 0 2-2.7l-3.3-18.9 13.9-13.3a2.4 2.4 0 0 0-1.4-4ZM43.4 36.7l2.8 15.7L32 45l-14.3 7.4 2.8-15.7-11.6-11 16-2.3L32 9l7.1 14.3 16 2.2-11.6 11.1Z"
}));
const ForwardRef = forwardRef(SvgStarEmpty);
export default ForwardRef;
